<template>
  <div class="max-w-md mx-auto bg-white p-8 shadow-lg rounded-lg">
    <div class="flex justify-center mb-6">
      <img :src="logo" alt="Logo" class="h-22 w-25 object-contain" />
    </div>
    <h1 class="text-2xl font-bold mb-6 text-gray-800">Enter Client Details</h1>
    <form @submit.prevent="submitForm">
      <div class="mb-4">
        <label class="block text-gray-600">Client Name:</label>
        <input v-model="client.name" required class="mt-1 p-2 w-full border rounded" />
      </div>
      <div class="mb-4">
        <label class="block text-gray-600">Client Email:</label>
        <input v-model="client.email" type="email" placeholder="Optional" class="mt-1 p-2 w-full border rounded" />
      </div>
      <div class="mb-4">
        <label class="block text-gray-600">Client Phone:</label>
        <input v-model="client.phone" placeholder="Optional" class="mt-1 p-2 w-full border rounded" />
      </div>
      <div class="mb-4">
        <label class="block text-gray-600">Intermediary Name:</label>
        <input v-model="client.intermediary" placeholder="Optional" class="mt-1 p-2 w-full border rounded" />
      </div>
      <div class="mb-6">
        <label class="block text-gray-600">Cover Type:</label>
        <select v-model="client.cover" required class="mt-1 p-2 w-full border rounded">
          <option value="jamii">Family Quote (Jamii Plus) </option>
          <option value="per-person">Per Person Quote (Jamii Plus)</option>
          <option value="child-only">Child Only Quote (Jamii Plus)</option>
          <option value="comparision">Comparison Quote (Jamii Plus)</option>
          <option value="afya-nafuu">Afya Nafuu</option>
          <option value="femina">Femina</option>
        </select>
      </div>
      <button type="submit" class="bg-blue-500 text-white p-2 rounded w-full hover:bg-blue-600">Next</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      client: {
        name: '',
        email: '',
        phone: '',
        intermediary: '',
        cover: '',
      },
      logo: require('@/assets/logo.png'), // Importing the logo
    };
  },
  methods: {
    submitForm() {
      localStorage.setItem('clientDetails', JSON.stringify(this.client));
      this.$router.push({ path: `/${this.client.cover}`, query: this.client });
    },
  },
};
</script>
